module.exports = __webpack_public_path__ + "img/dache.6d136e8e.png";